import { render, staticRenderFns } from "./TabFilterGeneral.vue?vue&type=template&id=2f1cdc02&scoped=true&"
import script from "./TabFilterGeneral.vue?vue&type=script&lang=coffee&"
export * from "./TabFilterGeneral.vue?vue&type=script&lang=coffee&"
import style0 from "./TabFilterGeneral.vue?vue&type=style&index=0&id=2f1cdc02&lang=sass&scoped=true&"
import style1 from "./TabFilterGeneral.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1cdc02",
  null
  
)

export default component.exports